export default __webpack_public_path__ + "static/media/IconYoutube.da19db49.svg";